export default [
  'Conveniência Bbank',
  'Bbankpay',
  'Telemedicina',
  'Créditos',
  'Seguros',
  'Investimentos',
  'Franquia',
];
